import { encodeLabel } from '@aytm/app/stats/lib/util/helpers'

// A trait value's name reaches the page as plain registry text -- unlike question text, which is
// encoded at rest -- while every consumer draws it as markup, so it is encoded here once.
export const getTraitValues = trait => {
  if (!trait) return null

  if (trait.values) {
    return trait.values.map(v => (v?.id != null ? { id: v.id, name: encodeLabel(v.name) } : { id: v, name: v }))
  }

  if (trait.answerVariants) {
    return trait.answerVariants.map(av => ({
      id: `a${av.position}`,
      name: `A${av.position}`
    }))
  }

  return null
}
